export default {options:{api:'storybook',version:1},children:[{model:'ticket',options:{key:'ticket',type:'refs'}}]}